import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from '../../services/Auth';

class AnalyticsApi extends Api {
  constructor(resource = '') {
    super(`analytics/${resource}`);
  }

  getFilters(params) {
    const apiUrl = process.env.REACT_APP_API_URL;
    const props = params?.props || {};
    return axios({
      url: `${apiUrl}/analytics/filters`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: params.responseType, // important
      ...props,
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  }
  getFootfalls(params) {
    return this.get('', params);
  }

  importExcel(data) {
    return this.buildQuery(
      'post',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      '',
    );
  }
}

export default AnalyticsApi;
